import { COOKIE_KEYS } from '@moniebook-web/types';
import {
    getItem,
    isExpired,
    MINUTES_TO_REFRESH_TOKEN_BEFORE_EXPIRY,
} from '@moniebook-web/utils';

export const isTokenExpired = () => {
    const token = getItem(COOKIE_KEYS.TOKEN_VARIABLE);
    const expiresAt = getItem(COOKIE_KEYS.TOKEN_EXPIRY_VARIABLE);
    return isExpired(token, expiresAt);
};

export const isTokenAlmostExpiring = () => {
    const now = Date.now();
    if (isTokenExpired()) {
        return false;
    }

    const expiresAt = getItem(COOKIE_KEYS.TOKEN_EXPIRY_VARIABLE);
    const expiryDate = new Date(expiresAt);
    const remainingMilliseconds = expiryDate.getTime() - now;
    const remainingMinutes = remainingMilliseconds / 1000 / 60;

    return remainingMinutes <= MINUTES_TO_REFRESH_TOKEN_BEFORE_EXPIRY;
};

export const getCountDownText = (milliseconds: number) => {
    const oneMinute = 1000 * 60;
    const minutes = milliseconds / oneMinute;
    const [fullMinutes, fractionalMinutes = ''] = minutes.toString().split('.');
    const remainingSeconds = +`0.${fractionalMinutes}` * 60;
    const displaySeconds = remainingSeconds.toFixed(0).padStart(2, '0');

    return `${fullMinutes}:${displaySeconds}`;
};
